import { useQuery } from '@tanstack/vue-query';
import { type Ref, unref } from 'vue';

import { QueryKeys } from '@/shared/constants/query-keys';

import { useApiClientService } from '../services/api-client.service';

export function useApiClient(apiClientId: Ref<string> | string) {
  const apiClientService = useApiClientService();

  return useQuery({
    queryKey: [QueryKeys.API_CLIENT, apiClientId],
    queryFn: () => apiClientService.getApiClient(unref(apiClientId)),
    select: (data) => ({
      ...data,
      defaultTemplate: data.defaultTemplate ? data.defaultTemplate.value : undefined,
    }),
    enabled: Boolean(unref(apiClientId)),
  });
}
